import HomeReservations from './HomeReservations'

export default HomeReservations